var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.isOnline)?_c('v-chip',{staticClass:"font-weight-bold online-chip",attrs:{"small":"","text-color":"green darken-4","color":"green lighten-4"}},[_c('v-icon',{attrs:{"left":"","small":"","color":"green darken-3"}},[_vm._v("mdi-circle")]),_vm._v(" Online ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }